import { useContext } from "react";
import { match } from "ts-pattern";

import { TrainingWelcomeDialogGeneric } from "./TrainingWelcomeDialogGeneric.js";
import { TrainingWelcomeDialogSoad } from "./TrainingWelcomeDialogSoad.js";
import { LoggedInUserContext } from "~/Contexts.js";

export function TrainingWelcomeDialog() {
  const userContext = useContext(LoggedInUserContext);

  return match(userContext?.user.sessionContext?.teamType)
    .with(undefined, () => null)
    .with(
      "amhp",
      "cqc",
      "generic",
      "mha",
      "mca",
      "ward",
      "independent",
      "guest",
      "section-12-payment-reviewers",
      () => <TrainingWelcomeDialogGeneric />,
    )
    .with("soad", () => <TrainingWelcomeDialogSoad />)
    .exhaustive();
}
